// App.js
import React, { useState, useEffect } from 'react';
import './App.css';

// 导入组件
import HeroSection from './components/HeroSection';
import HonorsSection from './components/HonorsSection';
import BenefitsSection from './components/BenefitsSection';
import QASection from './components/QASection';
import DirectionsSection from './components/DirectionsSection';
import FooterSection from './components/FooterSection';
import ScrollIndicator from './components/ScrollIndicator';
import SplashScreen from './components/SplashScreen';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  

  return (
    <div className="site-wrapper" style={{ background: '#FFFFFF' }}>
      <SplashScreen />
      <ScrollIndicator />
      <nav className={`site-nav ${scrolled ? 'scrolled' : ''}`} role="navigation" aria-label="主导航">
        <div className="nav-container">
          <div className="brand interactive-element">
            <img 
              src="/logo.jpg" 
              alt="YulinSec 御林安全工作室" 
              className="logo-img"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'scale(1.1) rotate(5deg)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'scale(1) rotate(0deg)';
              }}
            />
            <span className="brand-name">
              <span style={{ display: 'inline-block', transitionDelay: '0.1s' }}>Yu</span>
              <span style={{ display: 'inline-block', transitionDelay: '0.2s' }}>lin</span>
              <span style={{ display: 'inline-block', transitionDelay: '0.3s' }}>Sec</span>
            </span>
          </div>

          <div className="nav-links desktop">
            {[
              { name: '主页', icon: '' },
              { name: 'Q&A', icon: '' },
              { name: '方向选择', icon: '' },
              { name: '更多信息', icon: '' }
            ].map((item, index) => (
              <a
                key={item.name}
                href={`#${item.name}`}
                className="nav-link interactive-element"
                onClick={e => {
                  e.preventDefault();
                  document.getElementById(item.name)?.scrollIntoView({ behavior: 'smooth' });
                }}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
                  transform: 'perspective(1px) translateZ(0)',
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <span>{item.name}</span>
                <span style={{
                  position: 'absolute',
                  bottom: 0,
                  left: 0,
                  width: '100%',
                  height: '2px',
                  background: 'linear-gradient(90deg, #8B4513, #A0522D)',
                  transform: 'scaleX(0)',
                  transformOrigin: 'right',
                  transition: 'transform 0.3s ease'
                }}/>
                <span style={{
                  position: 'absolute',
                  top: '-100%',
                  left: '0',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.1), transparent)',
                  transition: 'top 0.5s ease'
                }}/>
              </a>
            ))}
          </div>

          <button 
            className="mobile-toggle interactive-element" 
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={mobileOpen}
            style={{
              position: 'relative',
              overflow: 'hidden',
              transition: 'all 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
              transform: 'perspective(1px) translateZ(0)'
            }}
          >
            <span style={{ position: 'relative', zIndex: 1 }}>
              {mobileOpen ? '✕' : '☰'}
            </span>
            <span style={{
              position: 'absolute',
              top: '0',
              left: '-100%',
              width: '100%',
              height: '100%',
              background: 'linear-gradient(90deg, transparent, rgba(139, 69, 19, 0.1), transparent)',
              transition: 'left 0.5s ease'
            }}/>
          </button>
        </div>

        {mobileOpen && (
          <div 
            className="mobile-menu" 
            role="menu"
            style={{
              transform: 'translateY(0)',
              opacity: 1,
              transition: 'all 0.3s cubic-bezier(0.23, 1, 0.32, 1)'
            }}
          >
            {[
              { name: '主页', icon: '' },
              { name: 'Q&A', icon: '' },
              { name: '方向选择', icon: '' },
              { name: '更多信息', icon: '' }
            ].map((item, index) => (
              <div
                key={item.name}
                className="mobile-item interactive-element"
                role="menuitem"
                onClick={() => {
                  setMobileOpen(false);
                  document.getElementById(item.name)?.scrollIntoView({ behavior: 'smooth' });
                }}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setMobileOpen(false);
                    document.getElementById(item.name)?.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                tabIndex={0}
                style={{
                  position: 'relative',
                  overflow: 'hidden',
                  transition: 'all 0.3s cubic-bezier(0.23, 1, 0.32, 1)',
                  transform: 'perspective(1px) translateZ(0)',
                  animationDelay: `${index * 0.1}s`
                }}
              >
                <span>{item.name}</span>
                <span style={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  width: '4px',
                  height: '100%',
                  background: 'linear-gradient(180deg, #8B4513, #A0522D)',
                  transform: 'scaleY(0)',
                  transition: 'transform 0.3s ease'
                }}/>
              </div>
            ))}
          </div>
        )}
      </nav>

      <main id="main-content">
        <HeroSection />
        <div style={{ 
          display: 'flex', 
          gap: 'var(--space-4)',
          maxWidth: '1400px',
          margin: '0 auto',
          alignItems: 'stretch'
        }}>
          <HonorsSection />
          <BenefitsSection />
        </div>
        <QASection />
        <DirectionsSection />
        <FooterSection />
      </main>
      
      {/* 添加跳转到主内容的链接，提升无障碍性 */}
      <a 
        href="#main-content" 
        className="skip-link"
        aria-label="跳转到主内容"
      >
        跳转到主内容
      </a>
    </div>
  );
}

export default App;